module.exports = __webpack_public_path__ + "img/Check List.5090b67d.svg";